import type { UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { CrmTaskInputDTO } from '../../../server/dto/crm-task-input-dto.ts';
import { useAppConfig } from '../../acl/acl-provider.tsx';
import { FileUploader } from '../../crm-attachment/components/file-uploader.tsx';
import { DialogForm } from '../../dialog/dialog-form.tsx';

type TaskAttachmentsFieldProps = {
    form: UseFormReturn<CrmTaskInputDTO>;
};

export const TaskAttachmentsField = ({ form }: TaskAttachmentsFieldProps) => {
    const { control } = form;
    const { enableFileUpload } = useAppConfig();

    if (!enableFileUpload) {
        return null;
    }

    return (
        <DialogForm.ItemList subgrid>
            <Controller
                name="attachments"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <FileUploader value={value ?? []} onChange={onChange} analyticsContext="task" />
                )}
            />
        </DialogForm.ItemList>
    );
};
